import { render, staticRenderFns } from "./RedactorX.vue?vue&type=template&id=21618f0c&scoped=true"
import script from "./RedactorX.vue?vue&type=script&lang=js"
export * from "./RedactorX.vue?vue&type=script&lang=js"
import style0 from "./RedactorX.vue?vue&type=style&index=0&id=21618f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21618f0c",
  null
  
)

export default component.exports